import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { UserAuthModalComponent } from "./user-auth-modal.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MaterialModule
    ],
    declarations: [UserAuthModalComponent],
    exports: [UserAuthModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserAuthModalModule {}